<ng-container *ngIf="dataLoaded">
    <div class="modal-body" *ngIf="nmvtisMessageModel?.nmvtisResponse">
        <h2>You cannot continue with the transaction.</h2>
        <h2>{{message}}</h2>
    </div>
    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--default" type="button" (click)="onAbortTransactionClick()">Exit and search for a different vehicle</button>
            <button class="btn--default" type="button" (click)="onCancelClick()">Cancel</button>
        </div>
    </div>
</ng-container>